import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import t from 'ember-intl/helpers/t';
import { Section, VStack } from 'tio-ui/components/layout';
import Button from 'tio-ui/components/button';
import Svg from 'tio-employee/components/svg';
import { PhCheck } from 'ember-phosphor-icons';

interface IdrDashboard0726WhatHappensNextSignature {
  Element: HTMLElement;
}

// Mirrors the legacy IDR "What happens next?" card (same copy), but the CTA
// re-runs this pilot's questionnaire.
export default class IdrDashboard0726WhatHappensNext extends Component<IdrDashboard0726WhatHappensNextSignature> {
  @service declare router: RouterService;

  goToForm = () => {
    this.router.transitionTo('authenticated.idr.dashboard-0726.questionnaire');
  };

  <template>
    <Section data-test-idr-0726-what-next ...attributes>
      <:header>{{t "idr.results.what_happens_next"}}</:header>
      <:body>
        <VStack class="tio-flex-center flex-col md:justify-start">
          <div class="max-w-24">
            <Svg
              @name="crystal-ball"
              role="img"
              width="100%"
              height="100%"
              aria-label={{t "svg.crystal_ball"}}
            />
          </div>
          <div class="flex">
            <PhCheck @size="32" weight="fill" class="tio-fg-success mx-1" />
            <p class="mr-4">{{t "idr.results.recertify"}}</p>
          </div>
          <div class="tio-flex-center md:justify-start">
            <PhCheck @size="32" weight="fill" class="tio-fg-success mx-1" />
            <p class="mr-2">{{t "idr.results.financial_circumstances"}}</p>
          </div>
          <Button class="mr-auto" @intent="primary" {{on "click" this.goToForm}}>
            {{t "idr.results.payment_button"}}
          </Button>
        </VStack>
      </:body>
    </Section>
  </template>
}
